const historyObjKey = 'ktgHistoryObj';
const collectionObjKey = 'ktgCollectionObj';
function getBreadcrumbCollectionSelectors () {
    return {
        "link": document.querySelector('.collection-breadcrumb-placeholder-link'),
        "text": document.querySelector('#collection-breadcrumb-placeholder')
    };
}

function setHistoryObject (pt = '', ct = ''){
    const ktgHistoryObj = {
        "previousTemplate": pt,
        "currentTemplate": ct
    }

    sessionStorage.setItem(historyObjKey, JSON.stringify(ktgHistoryObj));
}

function setCollectionObject (){
    if (window.currentTemplate === 'collection' && window.collectionTemplateData) {
        sessionStorage.setItem(collectionObjKey, JSON.stringify(window.collectionTemplateData));
    }
}

function updateBreadcrumbForProductPage (){
    let historyObj = null;
    let collectionObj = null;
    try {
        const rawHistory = sessionStorage.getItem(historyObjKey) || 'null';
        historyObj = JSON.parse(rawHistory);
    } catch (e) {
        console.warn('KTG failed to parse history obj', e);
    }
    try {
        const rawCollection = sessionStorage.getItem(collectionObjKey) || 'null';
        collectionObj = JSON.parse(rawCollection);
    } catch (e) {
        console.warn('KTG failed to parse collection obj', e);
    }

    const onProduct = window.currentTemplate === 'product';
    const cameFromCollection = !!historyObj && (
        historyObj.currentTemplate === 'collection' || historyObj.previousTemplate === 'collection'
    );

    const breadcrumbCollectionSelectors = getBreadcrumbCollectionSelectors();

    if (onProduct && cameFromCollection && collectionObj && breadcrumbCollectionSelectors.link && breadcrumbCollectionSelectors.text) {
        // Normalize and persist as collection -> product so a refresh keeps the breadcrumb
        if (historyObj.previousTemplate !== 'collection' || historyObj.currentTemplate !== 'product') {
            setHistoryObject('collection', 'product');
        }
        breadcrumbCollectionSelectors.link.setAttribute('href', collectionObj.url || '/');
        breadcrumbCollectionSelectors.text.textContent = collectionObj.title || '';
        breadcrumbCollectionSelectors.link.classList.remove('ktg-hide-container');
        return;
    }
    if (breadcrumbCollectionSelectors.link) {
        breadcrumbCollectionSelectors.link.classList.add('ktg-hide-container');
    }
    // Avoid overwriting history while on product, so a refresh preserves prior collection state
    if (!onProduct) {
        setHistoryObject(historyObj?.currentTemplate || '', window.currentTemplate);
    }
}

function validateHistoryObject () {
    let historyObj = null;
    try {
        const raw = sessionStorage.getItem(historyObjKey) || 'null';
        historyObj = JSON.parse(raw);
    } catch (e) {
        console.warn('KTG failed to parse history obj', e);
    }

    return !!(historyObj && historyObj.currentTemplate);
}

function ktgBreadcrumbInitialization () {
    const historyObjStatus = validateHistoryObject();
    if(!historyObjStatus) {
        setHistoryObject('', window.currentTemplate); 
        return;
    }
    updateBreadcrumbForProductPage(); 
} 

document.addEventListener('DOMContentLoaded', function (){
    setCollectionObject();
    ktgBreadcrumbInitialization();
});